import styled, { css as styledCSS } from "styled-components";

import * as EnvListBar from "../EnvironmentListBar/EnvironmentListBar.styles";

export const Children = styled.div`
  padding: 0 0 0 48px;
  margin-top: 16px;
`;

export const NodeLayout = styled.div<{
  depth: number;
  hasChildren?: boolean;
  isRoot?: boolean;
  status?: string;
}>`
  position: relative;
  line-height: 32px;

  & + & > ${EnvListBar.Wrapper} {
    &:after {
      top: -32px;
      height: 48px;
    }
  }

  > ${EnvListBar.Wrapper} {
    margin-bottom: 16px;
  }

  &:last-of-type > ${EnvListBar.Wrapper} {
    margin-bottom: 0;
  }

  ${({ hasChildren, isRoot }) =>
    !isRoot &&
    hasChildren &&
    styledCSS`
    > ${EnvListBar.Wrapper} ${EnvListBar.IconWrapper} {
      background-color: var(--icon-color-primary-600-background-color,var(--color-primary-600));
      > svg path {
        fill: var(--has-children-environment-icon-fill,var(--icon-snow-fill,var(--snow)));
      }
    }
  `}

  ${({ hasChildren, isRoot, status }) =>
    !isRoot &&
    hasChildren &&
    status === "inactive" &&
    styledCSS`
    > ${EnvListBar.Wrapper} ${EnvListBar.IconWrapper} {
      background-color: var(--icon-color-neutral-300-background-color,var(--color-neutral-300));
      > svg path {
        fill: var(--has-children-environment-icon-fill,var(--icon-granite-fill,var(--granite)));
      }
    }
  `}

  ${({ depth }) =>
    depth > 1 &&
    styledCSS`
      ${Children} {
        padding-left: 41px;
        margin-top: 12px;
      }
      ${EnvListBar.IconWrapper} {
        min-width: 24px;
        width: 24px;
        height: 24px;
      }
    `}

  ${({ isRoot }) =>
    !isRoot &&
    styledCSS<{ depth: number }>`
      &:before {
        position: absolute;
        content: "";
        background-color: var(--section-periwinkle-grey-background-color,var(--periwinkle-grey));
        height: 1px;
        top: 16px;
        left: -${({ depth }) => (depth <= 2 ? 32 : 29)}px;
        width: ${({ depth }) => (depth <= 2 ? 32 : 29)}px;
      }

      &:after {
        position: absolute;
        content: "";
        background-color: var(--section-periwinkle-grey-background-color,var(--periwinkle-grey));
        width: 1px;
        left: -${({ depth }) => (depth <= 2 ? 32 : 29)}px;
        top: -16px;
        bottom: 0;
        height: calc(100% + 16px);
      }

      &:last-child:after {
        top: -16px;
        height: 32px;
      }
    `}
`;
